import React from "react";
import AllPurchaseReturns from "./PurchaseReturnModule/AllPurchaseReturns";

const PurchaseReturns = () => {
  return (
    <div>
      <AllPurchaseReturns />
    </div>
  );
};

export default PurchaseReturns;
